import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/apps/website/components/base/Button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/website/components/base/Icon/Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/website/components/base/Icon/Logo/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/apps/website/components/base/Image/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/website/components/section/SectionCarousel/SectionSurveyCardCarousel/SectionSurveyCardCarousel.tsx");
